import ProductDescription from "../Product/ProductDescription";
import ProductDetailsTab from "../Product/ProductDetailsTab";

import PageBreadcrumb, {
  PageBreadcrumbItem,
} from "../../../common/PageBreadcrumb";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useParams, useNavigate } from "react-router-dom";
import { Product } from "../../../../data/ecommerce/storeCatalog";
import { getProduct } from "../../../../api/product/product";
import { useEffect, useState } from "react";
import Section from "../../../base/Section";
import { getProviderById } from "../../../../api";
import { Provider } from "../../../../data/ecommerce/providers";
import {
  getProductCategory,
  getSubCategories,
} from "../../../../helpers/utils";

const ProductDetails = () => {
  const navigate = useNavigate();
  const { productId } = useParams<{ productId: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [provider, setProvider] = useState<Provider | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchProduct = async () => {
      const data = await getProduct(Number(productId));
      const providerData = await getProviderById(data.providerId);
      setProvider(providerData);
      setProduct(data);
    };

    if (productId) {
      fetchProduct();
    }
  }, [productId]);

  if (!product) {
    return <div>Product not found</div>;
  }
  const category = getProductCategory(product.tagIds[0]);
  const section = getSubCategories(product.tagIds)[0];
  const breadcrumbItems: PageBreadcrumbItem[] = [
    { label: provider?.name || "", url: `/home/store/${provider?.uniqueName}` },
    {
      label: section,
      url: `/home/store/${provider?.uniqueName}#${product.tagIds[0]}`,
    },
    { label: product.name, active: true },
  ];

  return (
    <div className="pt-0 mb-9">
      <Section small className="py-0">
        <div className="d-flex align-items-center">
          <Link
            to="#"
            onClick={() => navigate(-1)}
            className="btn btn-link text-start ps-0"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
            Regresar
          </Link>

          <PageBreadcrumb
            items={breadcrumbItems}
            className="d-flex justify-content-start ps-0 align-items-center pt-4"
          />
        </div>
        {product && (
          <ProductDescription product={product} category={category} />
        )}
      </Section>

      <Section small className="py-0">
        <div className="mb-9">
          {product && <ProductDetailsTab product={product} />}
        </div>
      </Section>
    </div>
  );
};

export default ProductDetails;
